import axios from "axios";
import { TokenService } from "./auth/storage.services";

const ApiGateway = {
  baseURL: '',
  init(baseURL) {
    this.baseURL = baseURL;
  },

  getHeader(headers) {
    return Object.assign(headers || {}, {
      Authorization: `Bearer ${TokenService.getToken()}`,
      "Content-Type": "application/json; charset=UTF-8",
      "Accept": "application/json; v=1",
    });
  },

  setHeader() {
    axios.defaults.headers.common.Authorization = `Bearer ${TokenService.getToken()}`;
    axios.defaults.headers.common["Content-Type"] =
      "application/json; charset=UTF-8";
  },
  removeHeader() {
    TokenService.removeToken();
  },

  get(resource) {
    return new Promise((resolve, reject) => {
      const headers = this.getHeader(headers);
      axios
        .get(this.baseURL + resource, { headers })
        .then(function (response) {
          resolve(response);
        })
        .catch(function (error) {
          reject(error.response.data.message, error.response.status);
        });
    });
  },

  post(resource, data, headers) {
    headers = this.getHeader(headers);
    return new Promise((resolve, reject) => {
      axios
        .post(this.baseURL + resource, data, { headers: headers })
        .then(function (response) {
          resolve(response);
        })
        .catch(function (error, e) {
          if (error && error.response && error.response.data) {
            if (Array.isArray(error.response.data)) {
              reject(error.response.data.join("\n"));
            } else if (
              error.response.data.error &&
              Array.isArray(error.response.data.error)
            ) {
              reject(error.response.data.error.join("\n"));
            } else {
              reject(error.response.data.message);
            }
          } else {
            reject(error);
          }
        });
    });
  },

  download(resource, data, headers) {
    headers = this.getHeader(headers);
    return new Promise((resolve, reject) => {
      axios
        .post(this.baseURL + resource, data, { responseType: "blob", headers: headers })
        .then(function (response) {
          resolve(response);
        })
        .catch(function (error) {
          if (error && error.response && error.response.data) {
            reject(error.response.data.message);
          } else {
            reject(error);
          }
        });
    });
  },

  put(resource, data) {
    const headers = this.getHeader(headers);
    return new Promise((resolve, reject) => {
      axios
        .put(this.baseURL + resource, data, { headers })
        .then(function (response) {
          resolve(response);
        })
        .catch(function (error) {
          if (error && error.response && error.response.data) {
            if (
              error.response.data.error &&
              Array.isArray(error.response.data.error)
            ) {
              reject(error.response.data.error.join("\n"));
            } else {
              reject(error.response.data.message);
            }
          } else {
            reject(error);
          }
        });
    });
  },

  patch(resource, data) {
    const headers = this.getHeader(headers);
    return new Promise((resolve, reject) => {
      axios
        .patch(this.baseURL + resource, data, { headers })
        .then(function (response) {
          resolve(response);
        })
        .catch(function (error) {
          if (error && error.response && error.response.data) {
            if (
              error.response.data.error &&
              Array.isArray(error.response.data.error)
            ) {
              reject(error.response.data.error.join("\n"));
            } else {
              reject(error.response.data.message);
            }
          } else {
            reject(error);
          }
        });
    });
  },
  delete(resource) {
    const headers = this.getHeader(headers);
    return new Promise((resolve, reject) => {
      axios
        .delete(this.baseURL + resource, { headers })
        .then(function (response) {
          resolve(response);
        })
        .catch(function (error) {
          reject(error.response.data.message);
        });
    });
  },

  customRequest(data) {
    return axios(data);
  },
};

export default ApiGateway;
